import { config } from 'api';
import { getWhitelistedQuery, slugifyParam } from 'utils/url';

const translateNavigation = (basePath, location) => {
  const whitelistedQuery = getWhitelistedQuery(location.query);

  return {
    pathname: basePath,
    query: whitelistedQuery,
    state: {
      isCatalogueRedirect: true,
    },
  };
};

const navigationPathReplace = (basePath) => (nextState, replace) => {
  replace(translateNavigation(basePath, nextState.location));
};

export default [
  {
    path: 'navigation/start',
    onEnterHandlers: [
      navigationPathReplace('/navigation'),
    ],
  },
  {
    path: 'navigation/categories',
    onEnterHandlers: [
      navigationPathReplace('/navigation/browse'),
    ],
  },
  {
    path: 'navigation/inspirations',
    onEnterHandlers: [
      navigationPathReplace(`/navigation/${config.routes.navigation.highlighted}`),
    ],
  },
  {
    /*
     * Same path is used in Webshop for both normal and highlighted categories browsing. We're not able to distinguish
     * it here. Hence, always assume it's a regular category one, which is more common. In case it will actually be the
     * highlighted one, this will result in root /navigation/browse content being displayed.
     */
    path: 'navigation/:lastTagName/:tagIds',
    onEnterHandlers: [
      (nextState, replace) => {
        const { lastTagName, tagIds } = nextState.params;
        const tagIdsArr = tagIds ? tagIds.split('|').filter(Boolean) : [];

        let pathname = '/navigation/browse';
        for (let i = 0; i < tagIdsArr.length; ++i) {
          const isLast = i === tagIdsArr.length - 1;
          pathname = `${pathname}/${slugifyParam(isLast ? lastTagName : null, tagIdsArr[i])}`;
        }

        replace({
          pathname,
          query: getWhitelistedQuery(nextState.location.query),
          state: {
            isCatalogueRedirect: true,
          },
        });
      },
    ],
  },
];
